import HttpService from './HttpService';
const API_ENDPOINT = '/department'

const DepartmentService = {
  async getDepartments() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getDepartmentsPaginated(pageConfig) {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getDepartmentById(departmentId, data) {
    try {
        const response = await HttpService.get(`${API_ENDPOINT}/${departmentId}/edit`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
    }, 
  async getDepartmentsDivisionWise(divisionId) {
      try {
          const response = await HttpService.get(`department-get/${divisionId}`);
          return response.data;
      } catch (error) {
          throw error;
      }
    },
  async getDepartmentsByDivisions(divisionIds) {
      try {
          const response = await HttpService.post('departments-by-divisions', {
              division_ids: divisionIds,
          });
          return response.data;
      } catch (error) {
          throw error;
      }
    },
  async addDepartment(data) {
    try {
       const response = await HttpService.post(API_ENDPOINT, data);
       return response.data;
    } catch (error) {
        throw error;
    }
},
  async changeDepartmentStatus(data) {
    try {
       const response = await HttpService.post('/department-status-change', data);
       return response.data;
    } catch (error) {
        throw error;
    }
},
async updateDepatment(departmentId, data) {
  try {
      const response = await HttpService.put(`${API_ENDPOINT}/${departmentId}`, data);
      return response.data;
  } catch (error) {
      throw error;
  }
  },
  async deleteDepartment(departmentId) {
  try {
      const response = await HttpService.delete(`${API_ENDPOINT}/${departmentId}`);
      return response.data;
  } catch (error) {
      throw error;
  }
 }
};

export default DepartmentService;